<ng-content></ng-content>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/drop.down/item/drop.down.item.component.html